
<header class="all-transport-list__header">
  <div class="header__title-wrapper">
    <app-title />
    <app-close-button />
  </div>
  
  <div class="header__points-titles">
    <app-previous-point-title [previousPointTitle]="previousPointTitle()" />
    <app-current-point-title [currentPointTitle]="currentPointTitle()" />
  </div>
</header> 